module.exports = [
  ...require('./_magicItemRawList_DMG_h'),
  require('./hand_of_vecna'),
  require('./helm_of_brilliance'),
  require('./helm_of_comprehending_languages'),
  require('./heward_s_handy_haversack'),
  require('./holy_avenger'),
]
